var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 386.08 165.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#noName26);}.cls-2{fill:url(#noName7);}.cls-3{fill:url(#noName7-2);}.cls-4{fill:url(#noName7-3);}.cls-5{fill:url(#noName7-4);}.cls-6{fill:url(#noName7-5);}.cls-7{fill:url(#noName7-6);}.cls-8{fill:url(#noName7-7);}.cls-9{fill:url(#noName7-8);}.cls-10{fill:url(#noName7-9);}.cls-11{fill:url(#noName26-2);}.cls-12{fill:url(#noName26-3);}.cls-13{fill:url(#noName26-4);}.cls-14{fill:url(#noName26-5);}.cls-15{fill:url(#noName26-6);}.cls-16{fill:#d6d6d6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName26",
    x1: 123.9,
    y1: 11.05,
    x2: 41.29,
    y2: 154.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc9f1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7",
    x1: 18.55,
    y1: 119.56,
    x2: 118.53,
    y2: 119.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5d3ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-2",
    x1: 24.27,
    y1: 109.72,
    x2: 112.77,
    y2: 109.72,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-3",
    x1: 30,
    y1: 99.89,
    x2: 107.02,
    y2: 99.89,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-4",
    x1: 83.87,
    y1: 12.47,
    x2: 34.46,
    y2: 98.05,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-5",
    x1: 95.3,
    y1: 32.01,
    x2: 57.18,
    y2: 98.02,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-6",
    x1: 89.59,
    y1: 22.23,
    x2: 45.83,
    y2: 98.03,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-7",
    x1: 122.15,
    y1: 122.3,
    x2: 83.93,
    y2: 56.1,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-8",
    x1: 133.51,
    y1: 122.31,
    x2: 89.65,
    y2: 46.36,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName7-9",
    x1: 144.87,
    y1: 122.32,
    x2: 95.38,
    y2: 36.6,
    xlinkHref: "#noName7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName26-2",
    x1: 342.46,
    y1: -15.14,
    x2: 216.06,
    y2: 66.12,
    xlinkHref: "#noName26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName26-3",
    x1: 352.26,
    y1: 0.11,
    x2: 225.86,
    y2: 81.37,
    xlinkHref: "#noName26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName26-4",
    x1: 362.01,
    y1: 15.28,
    x2: 235.61,
    y2: 96.54,
    xlinkHref: "#noName26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName26-5",
    x1: 376.03,
    y1: 37.09,
    x2: 249.63,
    y2: 118.35,
    xlinkHref: "#noName26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noName26-6",
    x1: 388.86,
    y1: 57.05,
    x2: 262.46,
    y2: 138.31,
    xlinkHref: "#noName26"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0420\u0435\u0441\u0443\u0440\u0441 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-chack-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-chack-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 82.59,
    cy: 82.59,
    r: 82.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.53,123.55l-4.67-8H19.28a5.31,5.31,0,0,0,4.59,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.77,113.71l-4.66-8H25a5.3,5.3,0,0,0,4.59,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107,103.88l-4.66-8H30.72a5.31,5.31,0,0,0,4.59,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78,15.23,30.74,95.9H40L87.23,15.24h0A5.37,5.37,0,0,0,78,15.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.36,34.72,53.53,95.91h9.24L98.59,34.74h0A5.34,5.34,0,0,0,89.36,34.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.68,25,42.14,95.9h9.24L92.92,25h0A5.35,5.35,0,0,0,83.68,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.18,54.22l-4.62,7.89,36,61.44h0a5.3,5.3,0,0,0,4.58-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.88,44.49l-4.62,7.89,41.66,71.17h0a5.3,5.3,0,0,0,4.57-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M98.58,34.75,94,42.66l47.35,80.89h0a5.31,5.31,0,0,0,4.58-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M200.81,82.66l-2.43,12.46H188.1l10.62-49a7,7,0,0,1,6.86-5.53h7l10.61,54.55H213l-2.35-12.46Zm8.83-8.26L207.85,63c-.56-3.32-1.29-8.82-1.77-12.39h-.25c-.56,3.65-1.37,9.23-1.94,12.39l-2,11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M261.1,40.57V95.12H250.5V49.8h-8V64.2c0,12.55-.81,23.8-7.69,29.14A11.89,11.89,0,0,1,227.43,96l-2.26-9a8.65,8.65,0,0,0,3.64-1.86c3.24-3.32,3.88-9.39,3.88-20V40.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M281,40.57V61a23,23,0,0,1,4.29-.32c10.36,0,17,6.31,17,16.68,0,5.42-1.7,9.39-4.53,12.3-3.73,3.88-9.64,5.91-17.41,5.91a62.44,62.44,0,0,1-9.87-.65V40.57Zm.08,46.3a9,9,0,0,0,2,.16c5.42,0,8.17-4.13,8.17-9.07s-2.67-8.74-7.77-8.74a10.86,10.86,0,0,0-2.43.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M332.88,38.62v4.13c9.8,1.3,17.24,9,17.24,24.69,0,16.68-7.52,23.72-17.24,25.17v4.46h-9.39V92.61c-9.87-1.45-17.24-8.49-17.24-25,0-15.95,8.82-23.55,17.24-24.85V38.62Zm-9.31,11.82c-3.24,1-6.71,5.26-6.71,17.32,0,11.34,3.39,16.36,6.71,17.08Zm9.23,34.4c3.48-.81,6.72-5.1,6.72-17.4s-3.73-16.35-6.72-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M364.2,82.66l-2.43,12.46H351.49l11.82-54.55H376l9.14,47a6.31,6.31,0,0,1-6.2,7.52h-2.62L374,82.66ZM373,74.4,371.24,63c-.57-3.32-1.29-8.82-1.78-12.39h-.24c-.57,3.65-1.38,9.23-1.94,12.39l-2,11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M197.41,110.84v3h-5.78v3.82a8.66,8.66,0,0,1,1.44-.13A5.82,5.82,0,0,1,197,119a5.4,5.4,0,0,1,1.76,4.21,5.76,5.76,0,0,1-1.52,4.14c-1.24,1.31-3.22,2-5.83,2a20.72,20.72,0,0,1-3.31-.22v-18.2Zm-5.75,15.49a2.4,2.4,0,0,0,.78.08,2.47,2.47,0,0,0,2-.87,3.41,3.41,0,0,0,.67-2.11,3.22,3.22,0,0,0-.7-2.12,2.53,2.53,0,0,0-1.9-.87,3.35,3.35,0,0,0-.81.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M204.05,110.84v4c0,3.37-.21,6.51-.35,8.41h.06c.51-1.57,1.43-4,2-5.37l2.68-7.08h3.23v18.28h-3.12V125c0-3.66.13-6.37.24-8.22h-.05c-.43,1.63-1.25,3.83-1.84,5.37l-2.69,7h-3.28V110.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M214,111.68a7.6,7.6,0,0,1,4-1.05c3.47,0,5.1,2.11,5.1,4.5a4.28,4.28,0,0,1-3.09,4.15v0a4.34,4.34,0,0,1,3.6,4.58c0,3.5-3,5.43-6.24,5.43a8,8,0,0,1-3.71-.82l.54-2.9a5.78,5.78,0,0,0,2.82.74c1.9,0,2.9-1.09,2.9-2.55,0-2.07-1.68-2.85-3.58-2.85h-.54v-2.71h.38c1.6,0,3.23-.79,3.23-2.44a2,2,0,0,0-2.31-2.15,5.81,5.81,0,0,0-2.55.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M229.34,110.84v7.33h3.71v-7.33h3.56v18.28h-3.56v-7.65h-3.71v7.65h-3.55V110.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M247.46,121.09h-4.15V126H248v3.09h-8.24V110.84h7.94v3.1h-4.39v4.2h4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M259.2,128.85a7.22,7.22,0,0,1-2.74.43c-4.69,0-6.91-3.82-6.91-9,0-6.88,3.82-9.57,7.37-9.57a4.92,4.92,0,0,1,2.47.49l-.6,3a3.52,3.52,0,0,0-1.65-.35c-2,0-3.82,1.74-3.82,6.26s1.65,6.08,3.82,6.08a6.52,6.52,0,0,0,1.71-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M267.45,114.13h-3.23v-3.29h10v3.29H271v15h-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M283.83,121.09h-4.14V126h4.69v3.09h-8.25V110.84h7.95v3.1h-4.39v4.2h4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M292.71,129.12l-1.14-3.36c-.36-1.06-.68-2.09-1-3.26h-.08c-.3,1.17-.57,2.28-.84,3.31l-1,3.31h-3.52l3.41-9.35-3.28-8.93H289l1.09,3.39c.27,1,.54,1.9.81,2.93h.05c.3-1.11.55-2,.79-3l.92-3.34h3.55l-3.41,9.09,3.6,9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301.42,110.84v7.33h3.71v-7.33h3.55v18.28h-3.55v-7.65h-3.71v7.65h-3.56V110.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M322.63,119.66c0,6.89-2.44,9.68-5.92,9.68-4.14,0-5.77-4.4-5.77-9.41s2-9.3,6.05-9.3C321.38,110.63,322.63,115.48,322.63,119.66Zm-8,.32c0,4.15.78,6.27,2.22,6.27s2.09-2.71,2.09-6.43c0-3.2-.49-6.1-2.12-6.1C315.41,113.72,314.63,116.05,314.63,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M334.91,110.84v18.28h-3.55V113.94h-2.68v4.82c0,4.21-.27,8-2.58,9.76a3.94,3.94,0,0,1-2.47.9l-.76-3a3,3,0,0,0,1.23-.62c1.08-1.12,1.3-3.15,1.3-6.7v-8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M348.86,119.66c0,6.89-2.44,9.68-5.91,9.68-4.15,0-5.78-4.4-5.78-9.41s2-9.3,6.05-9.3C347.61,110.63,348.86,115.48,348.86,119.66Zm-8,.32c0,4.15.78,6.27,2.22,6.27s2.09-2.71,2.09-6.43c0-3.2-.49-6.1-2.12-6.1C341.64,113.72,340.86,116.05,340.86,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M359.52,110.84v3.1h-4.85v15.18h-3.56V110.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M364.57,110.84v4c0,3.37-.22,6.51-.36,8.41h.06c.51-1.57,1.44-4,2-5.37l2.68-7.08h3.23v18.28H369V125c0-3.66.14-6.37.25-8.22h-.06a56.57,56.57,0,0,1-1.84,5.37l-2.69,7h-3.28V110.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M378.48,110.84v4c0,3.37-.21,6.51-.35,8.41h.06c.51-1.57,1.43-4,2-5.37l2.68-7.08h3.23v18.28H383V125c0-3.66.13-6.37.24-8.22h-.05c-.44,1.63-1.25,3.83-1.85,5.37l-2.68,7h-3.28V110.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.91f44aed420b10e592292b71aa5ebcd5.svg";
export { ForwardRef as ReactComponent };